import React, { useEffect, useState } from 'react';
import { adminApi } from '../../services/adminApi';

const LABEL = {
  'vdaq-sync': 'V-DAQ sync (every 15 min)',
  'readiness-recompute': 'Readiness recalculation (hourly)',
  'readiness-digest': '05:00 readiness digest check (hourly)',
};

const fmt = (iso) => (iso ? new Date(iso).toLocaleString() : 'Never');
const SOURCE = {
  'azure-vm-systemd': 'Azure VM (production)',
  'emergent-scheduler': 'Emergent preview scheduler',
  pytest: 'Automated test',
};

// Super admin: last run of each scheduled job on THIS server.
export const ScheduledJobsCard = () => {
  const [jobs, setJobs] = useState(null);
  useEffect(() => {
    const load = () => adminApi.scheduledJobs().then(r => setJobs(r.data.jobs)).catch(() => setJobs([]));
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, []);
  if (!jobs) return null;
  return (
    <section className="space-y-3" data-testid="scheduled-jobs-card">
      <h2 className="text-sm uppercase tracking-widest text-muted-foreground">Scheduled jobs · one row per server that ran them</h2>
      <div className="rounded-md border border-border overflow-x-auto">
        <table className="w-full text-sm min-w-[560px]">
          <thead className="bg-secondary/40 border-b border-border">
            <tr className="text-[10px] uppercase tracking-widest text-muted-foreground">
              <th className="text-left px-3 py-2">Job</th><th className="text-left px-3 py-2">Health</th>
              <th className="text-left px-3 py-2">Last success</th><th className="text-left px-3 py-2">Last run</th>
              <th className="text-left px-3 py-2">Triggered by</th><th className="text-left px-3 py-2">Runs</th>
            </tr>
          </thead>
          <tbody>
            {jobs.map(j => (
              <tr key={`${j.job}-${j.source}`} className="border-b border-border last:border-0" data-testid={`scheduled-job-${j.job}-${j.source || 'none'}`}>
                <td className="px-3 py-2">{LABEL[j.job] || j.job}</td>
                <td className="px-3 py-2">
                  <span className={`text-[10px] font-mono uppercase tracking-widest border rounded-sm px-1.5 py-0.5 ${j.healthy ? 'text-emerald-400 border-emerald-500/30 bg-emerald-500/10' : 'text-red-400 border-red-500/30 bg-red-500/10'}`} data-testid={`scheduled-job-health-${j.job}`}>
                    {j.healthy ? 'Running' : 'Not running'}
                  </span>
                </td>
                <td className="px-3 py-2 font-mono text-xs" data-testid={`scheduled-job-last-success-${j.job}`}>{fmt(j.last_success_at)}</td>
                <td className="px-3 py-2 font-mono text-xs">{fmt(j.last_started_at)}{j.last_status === 'error' ? ' (error)' : ''}</td>
                <td className="px-3 py-2 text-xs">{SOURCE[j.source] || j.source || '—'}</td>
                <td className="px-3 py-2 font-mono text-xs">{j.run_count ?? 0}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
};
